import {
  EChannelTypeGlobal,
  EDatasetKey,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

export function getSearchTermsEDatasetKeyFromChannelTypeGlobal(
  channelType?: EChannelTypeGlobal
) {
  switch (channelType) {
    case EChannelTypeGlobal.SponsoredProduct:
      return EDatasetKey.SearchTermSp
    case EChannelTypeGlobal.DisplayAd:
      return EDatasetKey.SearchTermDa
    default: // eventually we should add generic and throw error if other
      return EDatasetKey.SearchTermSp
  }
}
